import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8712f95c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text--big" }, "or", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "sr-only" }, "Drop your Image", -1))
const _hoisted_3 = { class: "frame" }
const _hoisted_4 = { class: "frame__inner" }
const _hoisted_5 = { class: "form__wrapper" }
const _hoisted_6 = { class: "form__item" }
const _hoisted_7 = {
  class: "data-list-wrapper",
  "aria-live": "polite"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "data-list__title" }, "Success!", -1))
const _hoisted_9 = { class: "data-list" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "width:", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "height:", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "ratio:", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("input", {
              class: "form__file-upload",
              id: "file-upload",
              type: "file",
              accept: "image/*",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getImageInfos && _ctx.getImageInfos(...args)))
            }, null, 32),
            _createElementVNode("label", {
              class: _normalizeClass(["form__label form__label--upload", { 'form__label--has-file': _ctx.hasFile }]),
              for: "file-upload"
            }, " Upload your image to get size and ratio ", 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _withDirectives(_createElementVNode("div", null, [
        _hoisted_8,
        _createElementVNode("ul", _hoisted_9, [
          _createElementVNode("li", null, [
            _hoisted_10,
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(_ctx.width), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("span", null, _toDisplayString(_ctx.height), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_14,
            _hoisted_15,
            _createElementVNode("span", null, _toDisplayString(_ctx.ratio), 1)
          ])
        ])
      ], 512), [
        [_vShow, _ctx.hasFile]
      ])
    ])
  ], 32))
}